import { AuthService } from '@/services/auth.service.js'
import { encryptStorage } from '@/constants.js'
import store from '../index.js';

const state = {
  user: null,
  accessToken: encryptStorage.getItem('kindentaal-access-token') ?? null,
  error: null,
  success: null
}

const getters = {
  user: state => state.user,
  accessToken: state => state.accessToken,
  error: state => state.error,
  success: state => state.success
}

const actions = {
  async login ({ commit }, data) {
    return await AuthService.login(data).then(response => {
      if (typeof response.response === "undefined") {
        commit('SET_AUTH', response.data)
        commit('SET_USER', response.data.user)
      } else {
        commit('SET_ERROR', 'Ongeldige inloggegevens')
        return 'Ongeldige inloggegevens'
      }
    })
  },
  // eslint-disable-next-line no-unused-vars
  async forgotPassword ({ commit }, data) {
    return await AuthService.forgotPassword(data).then(response => {
      if (typeof response.response === "undefined") {
        commit('SET_SUCCESS', 'Er is een e-mail verstuurd naar het opgegeven e-mailadres')
      } else {
        commit('SET_ERROR', 'Er is iets misgegaan')
        return 'Er is iets misgegaan'
      }
    })
  },
  // eslint-disable-next-line no-unused-vars
  async resetPassword ({ commit }, data) {
    return await AuthService.resetPassword(data).then(response => {
      if (typeof response.response === "undefined") {
        commit('SET_SUCCESS', 'Het wachtwoord is succesvol gewijzigd')
      } else {
        commit('SET_ERROR', 'Er is iets misgegaan')
        return 'Er is iets misgegaan'
      }
    })
  },
  async getUser ({ commit }) {
    return await AuthService.getUser().then(response => {
      if (typeof response.response === "undefined") {
        commit('SET_USER', response.data.user)
      }
    })
  },
  async logout ({ commit }) {
    commit('CLEAR_AUTH')
  },
  removeError ({ commit }) {
    commit('SET_ERROR', '')
  },
  removeSuccess ({ commit }) {
    commit('SET_SUCCESS', '')
  }
}

const mutations = {
  SET_AUTH: (state, payload) => {
    encryptStorage.setItem('kindentaal-access-token', payload.access_token.toString())
    state.accessToken = payload.access_token.toString()
  },
  SET_USER: (state, payload) => {
    state.user = payload
  },
  SET_ERROR: (state, payload) => {
    state.error = payload
  },
  SET_SUCCESS: (state, payload) => {
    state.success = payload
  },
  CLEAR_AUTH: (state) => {
    encryptStorage.removeItem('kindentaal-access-token')
    state.user = null
    state.accessToken = null
    state.error = null
    state.success = null
    store.commit('clearLicenses')
    store.commit('clearOrganisations')
    store.commit('clearQRCodes')
    store.commit('clearSurveys')
    store.commit('clearUsers')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
